// src/main.js
import { createApp } from 'vue';
import App from './App.vue';
import { createHead } from '@vueuse/head';
import './assets/css/main.css';
import getRouter from './router'; // Import the function that returns the promise
import { inject } from '@vercel/analytics';

console.log('Starting application...');

// Define an async function to initialize and mount the app
async function initializeApp() {
  try {
    const router = await getRouter(); // Wait for the router promise to resolve
    const app = createApp(App);
    const head = createHead();

    app.use(router);
    inject();

    app.use(head);
    app.mount('#app');
    // Only log verbose messages in development
    if (process.env.NODE_ENV !== 'production') {
      console.log("Vue app mounted successfully.");
    }
  } catch (error) {
    console.error("Failed to initialize the application:", error); // Keep error logging for prod
    // Optionally display an error message to the user on the page
    document.getElementById('app').innerHTML = 'Failed to load application. Please try again later.';
  }
}

// Call the async function to start the app
initializeApp();